import CommLogComponent from "./CommLogComponent";

export default CommLogComponent;
